"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const types_1 = require("../types");
const BasicNode_1 = require("./BasicNode");
const validations_1 = require("../validations");
const fetchOutputKeys_1 = require("../helper/fetchOutputKeys");
const WEEKDAYS = [
  "this-is-error",
  "Sun",
  "Mon",
  "Tue",
  "Wed",
  "Thu",
  "Fri",
  "Sat"
];
const defaultCode =
  "async function process(){\n" +
  "  let result = 0;\n" +
  "  let {collection,region} = context;\n" +
  "  for(let i = 0;i< collection.length; i++){\n" +
  "    result += collection[i].key;\n" +
  "  }\n" +
  "  exit(null,result)\n" +
  "}\n" +
  "process().catch(exit);";
const convertCronToDays = d => {
  let search = /\((.*?)\)/.exec(d);
  if (search && search.length) {
    let split = search[1].split(" ");
    let hour = split[1];
    let min = split[0];
    let days = !split[4]
      ? []
      : split[4]
          .split(",")
          .map(u => (!isNaN(Number(u)) ? WEEKDAYS[Number(u)] : u));
    console.debug("mhd", min, hour, days);
    return {
      date: `${Number(hour) <= 9 ? "0" + hour : hour}:${
        Number(min) <= 9 ? "0" + min : min
      }`,
      days: days
    };
  }
  return { date: "00:00", days: [] };
};
class TriggerNode extends BasicNode_1.BasicNode {
  constructor(props) {
    if (!props) props = { type: types_1.NODE_TYPES.TRIGGER };
    if (props.type !== types_1.NODE_TYPES.TRIGGER)
      throw new Error("Invalid Node type");
    super(props);
  }
  getNodeData() {
    const input = super.getNodeData();
    if (
      input &&
      input.alarm &&
      input.alarm.value &&
      Array.isArray(input.alarm.value)
    ) {
      input.alarm.value = {
        namespace: "",
        metricNames: [],
        dimensions: "",
        statistics: []
      };
    }
    return input;
  }
  deserialize(data) {
    let nodeData = data || this.getNodeData();
    if (nodeData === null) return null;
    let httpValue = JSON.parse(JSON.stringify(nodeData.http.value || {}));
    if (!httpValue.hasOwnProperty("overrideGlobalVariables")) {
      httpValue.overrideGlobalVariables = true;
    }
    if (!httpValue.inputTransformers) {
      httpValue.inputTransformers = [];
    }
    httpValue.inputTransformers = httpValue.inputTransformers.map(x => {
      let type = x.link || "custom";
      x.link = type;
      x.code =
        type === "custom"
          ? { data: x.code || defaultCode, error: false }
          : undefined;
      return x;
    });
    return {
      alarm: {
        active: nodeData.alarm.active,
        value:
          nodeData.alarm.value && nodeData.alarm.value.namespace /// prevents old data to serialise
            ? nodeData.alarm.value
            : {
                namespace: "",
                metricNames: [],
                dimensions: "",
                statistics: []
              }
      },
      http: {
        active: nodeData.http.active,
        value: httpValue
      },
      schedule: {
        active: nodeData.schedule.active,
        value: this.getDesScheduleValue(nodeData)
      },
      event: {
        active: nodeData.event ? nodeData.event.active : false,
        value: nodeData.event
          ? nodeData.event.value
          : { eventIds: [], pattern: {} }
      },
      view: types_1.ViewType.SCHEDULE
    };
  }
  isFullCron(cron) {
    let search = /\((.*?)\)/.exec(cron);
    if (search && search.length) {
      let split = search[1].split(" ");
      if (split[2] !== "*" && split[2] !== "?") return true;
      if (split[3] !== "*" || split[5] !== "*") return true;
    }
    return false;
  }
  getDesScheduleValue(nodeData) {
    if (
      !nodeData ||
      !nodeData.schedule ||
      !nodeData.schedule.value ||
      !nodeData.schedule.value.length
    )
      return [];
    return nodeData.schedule.value.map(u => {
      if (
        (u.type === types_1.ScheduleType.CRON && this.isFullCron(u.value)) ||
        u.type === types_1.ScheduleType.PARSED_CRON
      )
        return {
          ...u,
          type: types_1.ScheduleType.PARSED_CRON,
          value:
            u.value &&
            u.value
              .trim()
              .replace(/^(parsed-)?cron\(/, "")
              .replace(/\)$/, "")
        };
      if (u.type === types_1.ScheduleType.CRON) {
        return {
          input: u.input,
          type: u.type,
          value: u.value,
          id: u.id,
          userSchema: u.userSchema,
          ...convertCronToDays(u.value)
        };
      }
      return u;
    });
  }
  serialize(uiData) {
    let nodeData = uiData;
    if (!nodeData) throw new Error("No data to serialize");
    const modify = u => {
      if (!u.date || !u.days)
        return {
          input: u.input,
          type: types_1.ScheduleType.CRON,
          value: "",
          id: u.id,
          userSchema: u.userSchema
        };
      let date = u.date.split(":");
      const hour = Number(date[0]).toString();
      const minute = Number(date[1]).toString();
      return {
        type: types_1.ScheduleType.CRON,
        value: `cron(${minute} ${hour} ? * ${u.days.join(",")} *)`,
        id: u.id,
        input: u.input,
        userSchema: u.userSchema
      };
    };
    let httpData = JSON.parse(JSON.stringify(nodeData.http || {}));
    if (
      httpData &&
      httpData.value &&
      httpData.value.inputTransformers &&
      httpData.value.inputTransformers.length
    ) {
      httpData.value.inputTransformers = httpData.value.inputTransformers.map(
        x => {
          let type = x.link || "custom";
          x.link = type !== "custom" ? type : undefined;
          x.code = type === "custom" && x.code ? x.code.data : undefined;
          return x;
        }
      );
    }
    return {
      http: httpData,
      alarm: nodeData.alarm,
      event: nodeData.event,
      schedule: {
        active: nodeData.schedule.active,
        value: nodeData.schedule.value.map(u => {
          if (u.type === types_1.ScheduleType.CRON) return modify(u);
          if (u.type === types_1.ScheduleType.PARSED_CRON)
            return {
              ...u,
              value: `${types_1.ScheduleType.PARSED_CRON}(${u.value})`
            };
          return u;
        })
      }
    };
  }
  getResourceOptionsFromHttpTrigger() {
    let resources = [];
    resources.push({
      nodeRef: this,
      label: this.getNodeName() + ".HttpPayload",
      selectedResourceId: this.getNodeId(),
      path: "",
      context: {
        outputPath: "HttpPayload"
      }
    });
    return resources;
  }
  getResourceOptionsFromScheduleTrigger() {
    let resources = [];
    resources.push({
      nodeRef: this,
      label: this.getNodeName() + ".Schedule",
      selectedResourceId: this.getNodeId(),
      path: "",
      context: {
        outputPath: "Schedule"
      }
    });
    return resources;
  }
  getResourceOptionsFromSNSTrigger() {
    let resources = [];
    resources.push({
      nodeRef: this,
      selectedResourceId: this.getNodeId(),
      path: "",
      label: [this.getNodeName(), "Alarms"].join("."),
      context: {
        outputPath: "Alarms"
      }
    });
    resources.push({
      selectedResourceId: this.getNodeId(),
      path: "Trigger.Dimensions",
      nodeRef: this,
      label: [this.getNodeName(), "Alarms", "Trigger.Dimensions"].join("."),
      context: {
        outputPath: "Alarms.Trigger..Dimensions"
      }
    });
    return resources;
  }
  async getAvailableResources() {
    let resources = [];
    let data = this.getNodeData();
    if (!data) return [];
    if (data.schedule && data.schedule.active) {
      resources = resources.concat(
        this.getResourceOptionsFromScheduleTrigger()
      );
    }
    if (data.http && data.http.active) {
      resources = resources.concat(this.getResourceOptionsFromHttpTrigger());
    }
    if (data.alarm && data.alarm.active) {
      resources = resources.concat(this.getResourceOptionsFromSNSTrigger());
    }
    return resources;
  }
  validate() {
    return new validations_1.TriggerNodeValidation().validate(this);
  }
  /**
   * always set id  =  nodeType = "trigger"
   * @param props
   */
  setId(props) {
    this.id = props.type;
  }
  /**
   * get output keys for given resource(optional)
   * (one node can have multiple available resources)
   * (Alarms,http trigger)
   * @param params
   */
  async getOutputKeys(params) {
    let nodeData = params.data || this.getNodeData();
    if (!nodeData) return [];
    let outputKeys = [];
    if (nodeData.alarm.active) {
      let alarmOutputKeys = await fetchOutputKeys_1.fetchOutputKeys(
        this.getDataResolver(),
        "TCCustom",
        "alarmTrigger"
      );
      outputKeys = outputKeys.concat(
        alarmOutputKeys.map(x => ({
          name: "Alarms." + x.name,
          value: "Alarms." + x.value
        }))
      );
    }
    if (
      nodeData.schedule &&
      nodeData.schedule.active &&
      nodeData.schedule.value &&
      nodeData.schedule.value.length &&
      nodeData.schedule.value[0].userSchema
    ) {
      // user schema is available at nodeData.http.value.userSchema
      let dataResolver = this.getDataResolver();
      if (dataResolver) {
        let httpOutputKeys = await dataResolver.resolve("getKeysFromSchema", {
          schema: nodeData.schedule.value[0].userSchema
        });
        outputKeys = outputKeys.concat(
          httpOutputKeys.map(x => ({
            name: "Schedule." + x,
            value: "Schedule." + x
          }))
        );
      }
    }
    if (
      nodeData.http.active &&
      nodeData.http.value &&
      nodeData.http.value.userSchema
    ) {
      // user schema is available at nodeData.http.value.userSchema
      let dataResolver = this.getDataResolver();
      if (dataResolver) {
        let httpOutputKeys = await dataResolver.resolve("getKeysFromSchema", {
          schema: nodeData.http.value.userSchema
        });
        outputKeys = outputKeys.concat(
          httpOutputKeys.map(x => ({
            name: "HttpPayload." + x,
            value: "HttpPayload." + x
          }))
        );
      }
    }
    if (
      !params.resource ||
      !params.resource.context ||
      !params.resource.context.outputPath
    )
      return outputKeys;
    return this.getKeysForPath(params.resource.context.outputPath, outputKeys);
  }
}
exports.TriggerNode = TriggerNode;
//# sourceMappingURL=TriggerNode.js.map
